import { Inject, Injectable } from "@angular/core";
import saveAs from 'file-saver';
import { Platform } from 'ionic-angular';
import { Observable } from 'rxjs/Rx';
import { EventNameAnalytics } from "../../helpers/event-name-analytics";
import { AnalyticsProvider } from "../../providers/analytics/analytics";
import {
    RequestDownloadExcelDto,
    RequestDownloadPdfDto,
    RequestSendEmailExcelDto,
    RequestSendEmailPdfDto
} from '../../shared/nestjs/gd-only/dto/business-trip-report.dto';
import { LoopBackAuth } from "../../shared/sdk";
import { FileDownloaderProvider } from './../../providers/file-downloader/file-downloader';
import { BusinessTripReportApi } from './../../shared/nestjs/gd-only/services/business-trip-report.api';
import { NestApiProvider } from './../../shared/nestjs/nest-api';
import { SFBusinesstripReportApi } from './../../shared/sdk/services/custom/SFBusinesstripReport';

@Injectable()
export class BusinessTripReportBloc {

    constructor(
        @Inject(LoopBackAuth) protected auth: LoopBackAuth,
        private businessTripReportApi: BusinessTripReportApi,
        private fileDownloaderProvider: FileDownloaderProvider,
        private platform: Platform,
        private nestApiProvider: NestApiProvider,
        private SFBusinesstripReportApi: SFBusinesstripReportApi,
        private analyticsProvider: AnalyticsProvider,
    ) { }

    generatePreview(data): Observable<any> {
        return this.SFBusinesstripReportApi.previewReport(data);
    }

    generateExcel(data) {
        if (this.platform.is('cordova')) {
            this.fileDownloaderProvider.downloadExcelBlob(data, 'Business Trip Report')
        } else {
            saveAs(data, 'Business Trip Report.xlsx')
        }
    }

    downloadExcel(data: RequestDownloadExcelDto): Observable<any> {
        this.analyticsProvider.trackEvent(EventNameAnalytics.REPORT_DOWNLOAD_EXCEL);
        return this.businessTripReportApi.downloadExcel(data);
    }

    downloadExcelLB(data): Promise<any> {
        return new Promise(async (resolve, reject) => {

        })
    }

    generatePdf(data) {
        if (this.platform.is('cordova')) {
            this.fileDownloaderProvider.downloadPdfBlob(data, 'Business Trip Report')
        } else {
            saveAs(data, 'Business Trip Report.pdf')
        }
    }

    downloadPdf(data: RequestDownloadPdfDto): Observable<any> {
        this.analyticsProvider.trackEvent(EventNameAnalytics.REPORT_DOWNLOAD_PDF);
        return this.businessTripReportApi.downloadPdf(data);
    }

    downloadPdfLB(data): Promise<any> {
        return new Promise(async (resolve, reject) => {

        })
    }

    sendExcel(data): Observable<any> {
        this.analyticsProvider.trackEvent(EventNameAnalytics.REPORT_SEND_MAIL);
        return Observable.fromPromise(this.nestApiProvider.isGoPathNewExist())
            .mergeMap(isGoPathNewExist => {
                if (isGoPathNewExist) {
                    let dataNest: RequestSendEmailExcelDto = new RequestSendEmailExcelDto();
                    console.log(dataNest, "dataNest")
                    dataNest.allEmp = data.allEmp;
                    dataNest.startDate = data.startDate;
                    dataNest.endDate = data.endDate;
                    dataNest.listEmp = data.listEmp;
                    dataNest.email = data.emailUser;
                    dataNest.fullName = data.fullName;
                    dataNest.purposeType = data.purposeType;
                    dataNest.reportType = data.reportType;
                    dataNest.showdeclare = data.showdeclare;
                    return this.businessTripReportApi.reportSendEmailExcel(dataNest);
                } else {
                    data.sendEmail = true;
                    return this.SFBusinesstripReportApi.download(data);
                }
            })
    }

    sendPdf(data): Observable<any> {
         this.analyticsProvider.trackEvent(EventNameAnalytics.REPORT_SEND_MAIL);
        return Observable.fromPromise(this.nestApiProvider.isGoPathNewExist())
            .mergeMap(isGoPathNewExist => {
                if (isGoPathNewExist) {
                    let dataNest: RequestSendEmailPdfDto = new RequestSendEmailPdfDto();
                    dataNest.allEmp = data.allEmp;
                    dataNest.startDate = data.startDate;
                    dataNest.endDate = data.endDate;
                    dataNest.listEmp = data.listEmp;
                    dataNest.email = data.emailUser;
                    dataNest.fullName = data.fullName;
                    dataNest.purposeType = data.purposeType;
                    dataNest.reportType = data.reportType;
                    dataNest.showdeclare = data.showdeclare;
                    return this.businessTripReportApi.reportSendEmailPdf(dataNest);
                } else {
                    data.sendEmail = true;
                    return this.SFBusinesstripReportApi.pdfmake(data);
                }
            })
    }
}


// WEBPACK FOOTER //
// ./src/bloc/report/business-trip-report.bloc.ts